export const menu = [
  {
    label: "Dashboard",
    link: "/",
  },
  {
    label: "Booking",
    link: "/booking",
  },
  {
    label: "Team",
    link: "/team",
  },
  {
    label: "Departments",
    link: "/departments",
  },
  {
    label: "Services",
    link: "/services",
  },
  {
    label: "News and updates",
    link: "/blogs",
  },
  {
    label: "Events",
    link: "/events",
  },
  {
    label: "Gallery",
    link: "/gallery",
  },
  {
    label: "Reviews",
    link: "/reviews",
  },
  {
    label: "FAQs",
    link: "/faqs",
  },
  {
    label: "Laws",
    link: "/laws",
  },
  {
    label: "Elements",
    link: "/elements",
  },
  {
    label: "WebContent",
    link: "/webcontent",
  },
];

export const BookingTab = [
  {
    label: "Pending",
    color: "#1b3121", // Purple
    active: "pending",
  },
  {
    label: "Processing",
    color: "#FFA500", // Orange
    active: "processing",
  },
  {
    label: "Unable to Contact",
    color: "#DC143C", // Crimson Red
    active: "Unable to Contact",
  },
  {
    label: "Offer Preparation",
    color: "#1E90FF", // Dodger Blue
    active: "Offer Preparation",
  },
  {
    label: "Offer Sent",
    color: "#32CD32", // Lime Green
    active: "Offer Sent",
  },
  {
    label: "Paused",
    color: "#808080", // Gray
    active: "Paused",
  },
  {
    label: "Closing",
    color: "#228B22", // Forest Green
    active: "Closing",
  },
];
export const InquriyData = [
  {
    label: "All",
    color: "#1b3121", // Purple
    active: "all",
  },
  {
    label: "Corporate Lease",
    color: "#1b3121", // Purple
    active: "corporate_lease",
  },
  {
    label: "Franchise",
    color: "#FFA500", // Orange
    active: "franchise",
  },
  {
    label: "Sale Order",
    color: "#DC143C", // Crimson Red
    active: "sale_order",
  },
  {
    label: "Feedback",
    color: "#1E90FF", // Dodger Blue
    active: "feedback",
  },
  
];

export const webContentTab = [
  {
    label: "Home",
    link: "/webcontent/home",
  },
  {
    label: "About Us",
    link: "/webcontent/about-us",
  },
  {
    label: "Our Blogs",
    link: "/webcontent/our-blogs",
  },
  {
    label: "Contact Us",
    link: "/webcontent/contact-us",
  },
  {
    label: "Testimonials",
    link: "/webcontent/testimonials",
  },
  {
    label: "Faqs",
    link: "/webcontent/faqs",
  },
  {
    label: "Promotions",
    link: "/webcontent/promotions",
  },
  {
    label: "Product Inner",
    link: "/webcontent/product-inner",
  },
  {
    label: "CorporateLease",
    link: "/webcontent/corporatelease",
  },
  {
    label: "Lease to own page",
    link: "/webcontent/lease-to-own-page",
  },
  {
    label: "vehicle listing",
    link: "/webcontent/vehicle-listing",
  },
  {
    label: "vehicle booking",
    link: "/webcontent/vehicle-booking",
  },
  {
    label: "thank you",
    link: "/webcontent/thank-you",
  },
  {
    label: "Term & Conditions",
    link: "/webcontent/term-and-conditions",
  },
  {
    label: "Privicy Policy",
    link: "/webcontent/privacy-policy",
  },
  {
    label: "Our Location",
    link: "/webcontent/our-locations",
  },
  {
    label: "Finalize",
    link: "/webcontent/finalize",
  },
  {
    label: "Cancellation Replacement Policy",
    link: "/webcontent/cancellation-replacement-policy",
  },
];

export const appContentTab = [
  {
    label: "On Boarding",
  },
  {
    label: "Terms and conditions",
  },
  {
    label: "Privacy",
  },
];
export const OtherPageTab = [
  {
    label: "Term & Conditions",
  },
  {
    label: "Privicy Policy",
  },
  {
    label: "Testimonials Video",
  },

];
